import { User } from '../models/models';
import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { CreateUserDTO } from '../models/dto';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(
    private apiService: ApiService
  ) {}

  async getUsers(): Promise<User[]> {
    return new Promise(async (resolve, reject) => {
      this.apiService.get<User[]>('/users', true).subscribe({
        next: (res) => {
          resolve(res.map(d => new User(d)));
        },
        error: (res) => {
          reject(res?.error);
        },
      });
    });
  }

  async createUser(data: CreateUserDTO): Promise<any> {
    return new Promise(async (resolve, reject) => {
      this.apiService.post<User>('/users', data, true).subscribe({
        next: (res) => {
          resolve(true);
        },
        error: (res) => {
          reject(res?.error);
        },
      });
    });
  }

  async deleteUser(id: number): Promise<any> {
    return new Promise(async (resolve, reject) => {
      this.apiService.delete<User>('/users/' + id, true).subscribe({
        next: (res) => {
          resolve(true);
        },
        error: (res) => {
          reject(res?.error);
        },
      });
    });
  }

  async getUser(userId: number, token: string = null): Promise<User> {
    if (token) {
      ApiService.token = token;
    }
    return new Promise(async (resolve, reject) => {
      this.apiService.get<User>('/users/' + userId, true).subscribe({
        next: (res) => {
          resolve(new User(res));
        },
        error: (res) => {
          reject(res?.error);
        },
      });
    });
  }

  async updateUser(userId: number, value: Partial<User>): Promise<User> {
    return new Promise(async (resolve, reject) => {
      this.apiService.put<User>('/users/' + userId, value, true).subscribe({
        next: (res) => {
          resolve(new User(res));
        },
        error: (res) => {
          reject(res?.error);
        },
      });
    });
  }
}
